import './app';
import './modulesService';

export default '7Terminal.Modules';
